import React, { useState, useEffect, useContext, useRef } from 'react';
import { TableFilterRow } from '@devexpress/dx-react-grid-bootstrap4';
import Select from 'react-select';
import { DataContext } from '../../stores/teacher-course-table-store';
import { HandleExlFilter } from '../tables/shared/FilterEventHelpers';
import { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import { courseStatusOptions, getOptionsObjectValuesWithLabel, courseRoleOptions } from './shared/translations';
import { useTranslation } from 'react-i18next';
import { SHOW_ALL } from '../../i18n/keyConstants';
registerLocale('sv', sv);

const FilterCell = ({ column, children, ...restProps }) => {
    const columnName = column.name;
    const { t } = useTranslation(['teacherDetails', 'shared']);

    const {
        store: {
            selectedFilters,
            filters,
            isResettingFilters,
            selectedCourseStatus,
        },
        dispatch
    } = useContext(DataContext);
    const [chosenValue, setChosenValue] = useState(selectedFilters[columnName]);

    const handleOptionValueChange = (selected) => {

        if (column.name === 'status') {
            { dispatch({ type: 'SELECTED_COURSE_STATUS', payload: selected }) }
        }
    }

    useEffect(() => {
        if (isResettingFilters) {
            setChosenValue('');
            dispatch({ type: 'SELECTED_FILTERS_AND_FILTERS_RESET', columnName, payload: '' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResettingFilters]);

    if (columnName === 'status') {
        if (selectedCourseStatus[0]?.label === 'showAll') {
            selectedCourseStatus[0].label = t(SHOW_ALL, { ns: 'shared' })
        }
        return (
            <th>
                <Select className={`${columnName}-select`}
                    isClearable={false}
                    isSearchable={false}
                    classNamePrefix='select-container'
                    value={selectedCourseStatus}
                    options={[...getOptionsObjectValuesWithLabel(courseStatusOptions, t), { label: t(SHOW_ALL, {ns: 'shared'}), value: ''}]}
                    onChange={(e) => {
                        HandleExlFilter(e, filters, handleOptionValueChange, columnName, 'equal', '', dispatch);
                    }}
                />
            </th>
        );
}

    var FilterOptions = children[0];
    var TextInput = React.cloneElement(children[1], {
        value: chosenValue,
        onChange: (event) => {
            setChosenValue(event);
            children[1].props.onChange();
        }
    });

    return (
        <TableFilterRow.Cell
            column={column}
            {...restProps}>
            {FilterOptions}
            {TextInput}
        </TableFilterRow.Cell>
    );
}

export default FilterCell;
